// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Acesso negado!',
  text: `Faltou alguma chave específica para acessar aquele recurso. Se precisar de alguma ferramenta que não
  tenha acesso atualmente, por favor procure um administrador.`,
  btn: {
    text: 'Que tal voltar à Home Page?',
    title: 'Clique aqui para voltar à Home Page',
  },
} as ILanguage;
